export const AbFeatureNames = {
  NUMBER_POOL: 'NUMBER_POOL',
  SIMONLYPLUS_UPSELL_DESIGN: 'SIMONLYPLUS_UPSELL_DESIGN',
  PX_ADDONS: 'PX_ADDONS',
  ESHOP_OTP_API: 'ESHOP_OTP_API',
  LINE_SELECTION: 'LINE_SELECTION',
  MTPOS_STOCK_CACHE: 'MTPOS_STOCK_CACHE',
  ESHOP_TIME_SLOT: 'ESHOP_TIME_SLOT',
  NGNIS_ADDRESS_UPDATE: 'NGNIS_ADDRESS_UPDATE',
  ESHOP_RECAPTCHA: 'ESHOP_RECAPTCHA',
  DELETE_PENDING_ORDER_FOR_NEW_FLOW: 'DELETE_PENDING_ORDER_FOR_NEW_FLOW',
  ESHOP_BILLING_PREFERENCE: 'ESHOP_BILLING_PREFERENCE',
  BTL_LINE_SELECTION: 'BTL_LINE_SELECTION',
  BTL_PX_ADDONS: 'BTL_PX_ADDONS',
  ESHOP_CREATE_ORDER: 'ESHOP_CREATE_ORDER',
  CCE_ESHOP_API: 'CCE_ESHOP_API',
  ESHOP_LOGOUT: 'ESHOP_LOGOUT',
  ESHOP_VOUCHER: 'ESHOP_VOUCHER',
  ESHOP_ORDER: 'ESHOP_ORDER',
  ESHOP_VALIDATE_CIS: 'ESHOP_VALIDATE_CIS',
  ESHOP_CIS_DOC_UPDATE: 'ESHOP_CIS_DOC_UPDATE',
  RRP_IPP_PROMO: 'RRP_IPP_PROMO',
  ENHANCED_ERROR_HANDLER: 'ENHANCED_ERROR_HANDLER'
};
